module.exports = __webpack_public_path__ + "cr.svg?0d349fd2526b99ef265d29d840611ce6";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/4x3/cr.svg
// module id = 1053
// module chunks = 0